import moment from 'moment';
import React, { useState } from 'react'
import { Calendar, utils } from '@hassanmojab/react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';

const DatePickerView = (props) => {
    const [selectedDay, setSelectedDay] = useState(props.selectedDay);
    const nextMonthLastDate = moment().add(1, "M");
    const maximumDate = {
        year: nextMonthLastDate.year(),
        month: nextMonthLastDate.month() + 1,
        day: nextMonthLastDate.date()
    }


    const onChange = (val) => {
        setSelectedDay(val);
        var date = new Date(val.year, val.month - 1, val.day);
        props.onChange(moment(date).toDate());
    }
    return (
        <Calendar
            value={selectedDay}
            onChange={onChange}
            shouldHighlightWeekends
            colorPrimary='linear-gradient(102.41deg, rgba(96, 180, 231, 0.8) -0.17%, rgba(100, 97, 224, 0.8) 70.6%)'
            colorPrimaryLight="linear-gradient(102.41deg, rgba(96, 180, 231, 0.8) -0.17%, rgba(100, 97, 224, 0.8) 70.6%)"
            slideAnimationDuration='0.1s'
            minimumDate={utils().getToday()}
            maximumDate={maximumDate}       
        />
    )
}

export default DatePickerView